import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { PencilIcon } from "lucide-react";

interface Media {
  media_id: number;
  media_name: string;
  media_descr: string | null;
  uniq: string | null;
  is_available: boolean | null;
}

interface MediaListProps {
  media: Media[];
  onEdit: (media: Media) => void;
}

export function MediaList({ media, onEdit }: MediaListProps) {
  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Description</TableHead>
            <TableHead>Unique ID</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {media.map((item) => (
            <TableRow key={item.media_id}>
              <TableCell className="font-medium">
                {item.media_name}
              </TableCell>
              <TableCell>
                {item.media_descr || "No description"}
              </TableCell>
              <TableCell>
                <span className="text-sm font-mono">
                  {item.uniq || "N/A"}
                </span>
              </TableCell>
              <TableCell>
                <Badge
                  variant={item.is_available ? "default" : "secondary"}
                >
                  {item.is_available ? "Available" : "Unavailable"}
                </Badge>
              </TableCell>
              <TableCell>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onEdit(item)}
                >
                  <PencilIcon className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}